import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'
import Layout from '@/layouts/Layout.vue'
import i18n from '@/i18n'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: {
      title: '登录',
      requiresAuth: false
    }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: {
          title: 'menu.dashboard', // 使用国际化 key
          requiresAuth: true
        }
      },
      {
        path: 'system/config',
        name: 'SystemConfig',
        component: () => import('@/views/SystemConfigView.vue'),
        meta: {
          title: 'menu.systemConfig', // 使用国际化 key
          requiresAuth: true
        }
      },
      {
        path: 'conversations',
        name: 'Conversations',
        component: () => import('@/views/ConversationsView.vue'),
        meta: {
          title: 'menu.conversations', // 使用国际化 key
          requiresAuth: true
        }
      },
      {
        path: 'feedback-records',
        name: 'FeedbackRecords',
        component: () => import('@/views/FeedbackRecordsView.vue'),
        meta: {
          title: 'menu.feedbackRecords', // 使用国际化 key
          requiresAuth: true
        }
      },
      {
        path: 'model/annotation',
        name: 'ModelAnnotation',
        component: () => import('@/views/ModelAnnotationView.vue'),
        meta: {
          title: 'menu.modelAnnotation', // 使用国际化 key
          requiresAuth: true
        }
      },
      {
        path: 'model/training',
        name: 'ModelTraining',
        component: () => import('@/views/ModelTrainingView.vue'),
        meta: {
          title: 'menu.modelTraining', // 使用国际化 key
          requiresAuth: true
        }
      },
      // {
      //   path: 'knowledge/base',
      //   name: 'KnowledgeBase',
      //   component: () => import('@/views/KnowledgeBaseView.vue'),
      //   meta: {
      //     title: 'menu.knowledgeBase', // 使用国际化 key
      //     requiresAuth: true
      //   }
      // },
      // {
      //   path: 'model/config',
      //   name: 'ModelConfig',
      //   component: () => import('@/views/ModelConfigView.vue'),
      //   meta: {
      //     title: 'menu.modelConfig', // 使用国际化 key
      //     requiresAuth: true
      //   }
      // },
      {
        path: 'system/prompt',
        name: 'SystemPrompt',
        component: () => import('@/views/SystemPromptView.vue'),
        meta: {
          title: 'menu.systemPrompt', // 使用国际化 key
          requiresAuth: true
        }
      }
      // {
      //   path: 'user/management',
      //   name: 'UserManagement',
      //   component: () => import('@/views/UserManagementView.vue'),
      //   meta: {
      //     title: 'menu.userManagement', // 使用国际化 key
      //     requiresAuth: true
      //   }
      // }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由导航守卫
router.beforeEach((to, from, next) => {
  const token = getToken()
  
  // 设置页面标题（使用国际化）
  if (to.meta.title) {
    const titleKey = to.meta.title
    const title = i18n.global.t(titleKey)
    const systemName = i18n.global.t('common.systemNameSuffix')
    document.title = `${title} - ${systemName}`
  }
  
  // 语言处理：登录页面使用浏览器默认语言，登录后的页面使用保存的语言
  if (to.path === '/login') {
    // 访问登录页时，强制使用浏览器默认语言（忽略 localStorage）
    const browserLang = navigator.language || navigator.userLanguage
    const browserLocale = browserLang.startsWith('zh') ? 'zh-CN' : 'en-US'
    // 切换到浏览器默认语言
    if (i18n.global.locale.value !== browserLocale) {
      i18n.global.locale.value = browserLocale
    }
  } else if (to.meta.requiresAuth) {
    // 访问需要登录的页面时，从 localStorage 读取语言设置
    const savedLocale = localStorage.getItem('admin_locale')
    if (savedLocale === 'zh-CN' || savedLocale === 'en-US') {
      // 如果保存的语言与当前语言不同，切换到保存的语言
      if (i18n.global.locale.value !== savedLocale) {
        i18n.global.locale.value = savedLocale
      }
    }
  }
  
  // 检查是否需要登录
  if (to.meta.requiresAuth) {
    if (!token) {
      // 未登录，跳转到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    // 不需要登录的页面（如登录页）
    if (token && to.path === '/login') {
      // 已登录，跳转到首页
      next('/dashboard')
    } else {
      next()
    }
  }
})

export default router
